'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.seconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/seconds.js
// module id = 734
// module chunks = 0